export const existsModule = function (module) {
    if (localStorage.getItem('userData') && localStorage.getItem('modules')) {
        return JSON.parse(localStorage.getItem('modules'))[`${module}`]
    }   
}